module.exports = __webpack_public_path__ + "img/download-blue-icon.9ed75e85.svg";